import { CORE } from "./commonRepository";

/**
 * Create conversations
 * @version 1.0.0
 * @author Luis Rafael Geraldo <lgeraldo@gcunit.com>    
 * @param  {Object}
 * @return {Object|Array}
 **/
export const Create = async (model) =>{
    try{
        const result = await CORE.post('v1/conversations', model);
        return result;
    }catch(error){
        return error.response;
    }
};

/**
 * List of conversation
 * @version 1.0.0
 * @author Luis Rafael Geraldo <lgeraldo@gcunit.com>    
 * @param  {Object}
 * @return {Object|Array}
 **/
export const GetAll = async (filter) =>{
    try{
        const result = await CORE.get('v1/conversations', {
            params: filter
        });
        return result;
    }catch(error){
        return error.response;
    }
};


/**
 * List of conversation
 * @version 1.0.0
 * @author Luis Rafael Geraldo <lgeraldo@gcunit.com>    
 * @param  {Object}
 * @return {Object|Array}
 **/
export const GetMessagesById = async (idConversation) =>{
    try{
        const result = await CORE.get(`v1/conversations/${idConversation}/messages`);
        return result;
    }catch(error){
        return error.response;
    }
};


